import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import { TECH_ECOSYSTEM } from "../../data/content";

export default function TechEcosystem() {
  return (
    <section className="ad-section bg-[#F7F8FA]" data-testid="tech-ecosystem">
      <div className="ad-container">
        <SectionHeading
          eyebrow="Technology Ecosystem"
          title={<>Built with <span className="text-gradient">modern data technology.</span></>}
          sub="We work across the modern data and AI stack — matched to your environment, not ours."
        />
        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {TECH_ECOSYSTEM.map((cat, i) => (
            <Reveal key={cat.category} index={i % 3}>
              <div className="ad-card h-full p-7">
                <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#1677FF]">{cat.category}</h3>
                <div className="mt-5 flex flex-wrap gap-2">
                  {cat.items.map((t) => (
                    <span key={t} className="rounded-lg border border-[#111827]/10 bg-[#F7F8FA] px-3 py-1.5 text-sm text-[#374151] transition-colors hover:border-[#1677FF]/40 hover:text-[#1677FF]">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
